<template>
  <v-flex pt-1 pl-2 pr-7 >
    <v-row justify="space-between" style="color: #871400; font-size: 12px;">
      <p v-if="!bestDriver"> </p>
      <p
        v-if="bestDriver"
      >ETA: {{ bestDriver.minutesFromPickup }} mins ({{ pickupTimeETA }}) - {{ bestDriver.callsign }} {{ bestDriver.name }}</p>
      <BookTripETARoute :bookingForm="bookingForm" />
      <p
      >{{ freeTaxisForZone.length }} / {{ taxisForZone.length }} Drivers in Zone {{ bookingForm.booking.zone != null ? bookingForm.booking.zone.name : '' }}</p>

    </v-row>
  </v-flex>
</template>

<script>
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

import BookTripETARoute from "@/components/widget/input/BookTripETARoute.vue";


export default {
  name: "BookingNearestDriverSummary",
  model: {
    prop: "preassignedDriver",
    event: "input"
  },
  props: {
    taxis: Array,
    bookingForm: Object,
    zones: Array
  },
  components: {
    BookTripETARoute,
  },
  computed: {
    pickupTimeETA: function() {

      var put = this.bookingForm.booking.pickup_datetime;

      if (put == null) {
        put = new Date();
      }

      return moment(put).add(this.bestDriver.minutesFromPickup, "minutes").format("HH:mm");  
    },
    bestDriver: function () {
      return this.bookingForm.booking.bestDriver;
    },
    items: function() {
      return this.bookingForm.booking.eligibleDriversForPreassign;
    },
    taxisForZone: function() {

      var self = this;

      if (self.bookingForm == null  || self.bookingForm.booking.zone == null) {
        return [];
      }

      return this.taxis.filter(function(t) {
        return t.zone == self.bookingForm.booking.zone.id;
      });
    },
    freeTaxisForZone: function(id) {
      return this.taxisForZone.filter(function(t) {
        return t.state == 'available';
      })
    },
  },
  data() {
    return {
      menu: false,
      drivers: [],
      loading: false
    };
  },
  methods: {
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    willBeActive(p) {
      return this.bookingForm.promocodeWillBeActive(p);
    },
    htmlForDriver(item) {
      return (
        "<p><b>" + item.callsign + "&nbsp;-&nbsp;</b>" + item.name + "</p>"
      );
    },
    htmlForPromocodeExtended(item) {
      return (
        "<p><b>" +
        item.promocode.code +
        "</b><br>" +
        item.promocode.promotion.description
      );
    },
    updateSelf(rideType) {
      this.$emit("input", rideType);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");

      this.bookingForm.getEligibleDriversForPreassign();

      this.$forceUpdate();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
